export const TICKET_STATUS_CONFIG: Record<string, { color?: string; background?: string }> = {
  'Abierto': { color: 'var(--color-snackbar-info)', background: 'var(--color-primary-light)' },
  'Open': { color: 'var(--color-snackbar-info)', background: 'var(--color-primary-light)' },
  'En Atención': { color: 'var(--color-snackbar-success)', background: 'var(--color-success-soft)' },
  'In Attention': { color: 'var(--color-snackbar-success)', background: 'var(--color-success-soft)' },
  'En Proceso': { color: 'var(--color-snackbar-info)', background: 'var(--color-primary-light)' },
  'On Process': { color: 'var(--color-snackbar-info)', background: 'var(--color-primary-light)' },
  'Aprobado': { color: 'var(--color-snackbar-success)', background: 'var(--color-success-soft)' },
  'Approved': { color: 'var(--color-snackbar-success)', background: 'var(--color-success-soft)' },
  'Cerrado': { color: 'var(--color-snackbar-error)', background: 'var(--color-danger-soft)' },
  'Closed': { color: 'var(--color-snackbar-error)', background: 'var(--color-danger-soft)' },
  // Approval statuses
  'Pendiente': { color: 'var(--color-snackbar-info)', background: 'var(--color-primary-light)' },
  'Rechazado': { color: 'var(--color-snackbar-error)', background: 'var(--color-danger-soft)' },
};

export const TICKET_ACCENT_BY_STATUS: Record<string, string> = {
  'Abierto': 'var(--color-text-primary)',
  'Open': 'var(--color-text-primary)',
  'En Atención': 'var(--color-snackbar-success)',
  'In Attention': 'var(--color-snackbar-success)',
  'En Proceso': 'var(--color-info)',
  'On Process': 'var(--color-info)',
  'Aprobado': 'var(--color-warning)',
  'Approved': 'var(--color-warning)',
  'Cerrado': 'var(--color-danger)',
  'Closed': 'var(--color-danger)',
  // Approval statuses
  'Pendiente': 'var(--color-info)',
  'Rechazado': 'var(--color-danger)',
  'Aprobado por QC': 'var(--color-success)',
};
export const STORAGE_KEY = 'preferred-language';

export const TICKET_STATES_ALLOWING_ACTION = ['En Atención', 'In Attention', 'Working'];

export const ERROR_MESSAGES: Record<number, string> = {
  0: 'No se puede conectar al servidor',
  401: 'No autorizado',
  403: 'Acceso denegado',
  404: 'Recurso no encontrado',
  500: 'Error interno',
};

export const mapMarksColors = ['#3b82f6', '#22c55e', '#f59e0b', '#ef4444'];


// Códigos de Closing Fields
export const CLOSING_FIELD_CODE = {
  TICKET_STATUS: '101',
  USER_PROFILE_FIELD_1: '105',
  USER_PROFILE_FIELD_2: '106',
  SITUACION_LABORAL_1: '107',
  SITUACION_LABORAL_2: '108',
  INGRESO_MENSUAL_1: '109',
  INGRESO_MENSUAL_2: '111',
  CREDITOS_VIGENTES: '113',
  EGRESO_MENSUAL: '114',
  UBICACION_CAPTURA_1: '115',
  UBICACION_CAPTURA_2: '116',
  USER_PROFILE_FIELD_3: '118',
  USER_PROFILE_FIELD_4: '119',
  USER_PROFILE_FIELD_5: '120',
  USER_PROFILE_FIELD_6: '121',
  REFERENCIA_1_NOMBRE: '122',
  REFERENCIA_1_PARENTESCO: '123',
  REFERENCIA_1_TIEMPO: '124',
  REFERENCIA_1_TELEFONO: '125',
  REFERENCIA_2_NOMBRE: '132',
  REFERENCIA_2_PARENTESCO: '133',
  REFERENCIA_2_TIEMPO: '134',
  REFERENCIA_2_TELEFONO: '135',
  LATITUD_LONGITUD_USER: '142',
  LATITUD_LONGITUD_FORMULARIO: '143',
  LATITUD_LONGITUD_EVIDENCIAS: '144',
} as const;

export function getCurrentDateString(): string {
  const now = new Date();
  const day = String(now.getDate()).padStart(2, '0');
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const year = now.getFullYear();
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');
  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
}

  export function parseNumber(value: string | undefined): number {
    if (!value) return 0;
    const cleaned = value.replace(/[^0-9.-]/g, '');
    return parseFloat(cleaned) || 0;
  }

  export function formatCurrency(value: number): string {
    return '$' + value.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }